import {
  ActionIcon,
  createStyles,
  Flex,
  MantineTheme,
  Space,
  Stepper,
  Title,
} from "@mantine/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { STEP } from "./types.d";
import { IconArrowLeft, IconCheck } from "@tabler/icons-react";
import DepositSettlementStepOne from "./deposit-settlement-step-1/DepositSettlementStepOne";
import DepositSettlementStepTwo from "./deposit-settlement-step-2/DepositSettlementStepTwo";
import { useNavigate } from "react-router-dom";
import DepositSettlementStepThree from "./deposit-settlement-step-3/DepositSettlementStepThree";
import { PreviewSavingsResponse } from "@/dto/savings/Savings";

interface Props {
  step: number;
  submitStepOne?: () => void;
  submitStepTwo?: () => void;
  submitStepThree?: () => void;
  onBackStepOne?: () => void;
  onChangeSourceLinkId?: (id: string, availableBalance: number) => void;
  dataWithdraw?: PreviewSavingsResponse;
  isLoadingStepOne?: boolean;
  isLoadingOtp?: boolean;
  dataStepThree?: { key: string; value: string; name: string }[];
}

const useStylesStepper = createStyles((theme: MantineTheme) => ({
  stepIcon: {
    "&[data-progress]": {
      borderWidth: 0,
      backgroundColor: theme.colors.primary[7],
      color: "#fff",
    },
    "&[data-completed]": {
      borderWidth: 0,
      backgroundColor: theme.colors.green[7],
      color: "#fff",
    },
  },
}));

const DepositSettlementContainer: React.FC<Props> = ({
  step,
  submitStepOne,
  submitStepTwo,
  submitStepThree,
  onBackStepOne,
  onChangeSourceLinkId,
  dataWithdraw,
  isLoadingStepOne,
  isLoadingOtp,
  dataStepThree,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { classes: classesStepper } = useStylesStepper();
  return (
    <>
      <Flex gap={4} justify="space-between" style={{ alignItems: "center" }}>
        <Flex align="center" gap={8}>
          <ActionIcon variant="transparent" onClick={() => navigate(-1)}>
            <IconArrowLeft />
          </ActionIcon>
          <Title
            order={4}
            sx={{
              margin: "0",
              paddingLeft: 10,
              backgroundClip: "padding-box, border-box",
              color: "inherit",
            }}
            fz={24}
          >
            {t("DEPOSIT_SETTLEMENT")}
          </Title>
        </Flex>
        {step !== STEP.STEP_3 && (
          <Stepper
            completedIcon={<IconCheck />}
            w="30%"
            active={step - 1}
            breakpoint="md"
            classNames={classesStepper}
            allowNextStepsSelect={false}
            mt={10}
          >
            <Stepper.Step icon={1} label={`${t("SETTLEMENT_INFORMATION")}`} />
            <Stepper.Step icon={2} label={`${t("CONFIRM")}`} />
          </Stepper>
        )}
      </Flex>
      <Space h={20} />
      {step === 1 && (
        <DepositSettlementStepOne
          onSubmit={submitStepOne}
          onChangeSourceLinkId={onChangeSourceLinkId}
          dataWithdraw={dataWithdraw}
          isLoadingStepOne={isLoadingStepOne}
        />
      )}
      {step === 2 && (
        <DepositSettlementStepTwo
          onSubmit={submitStepTwo}
          onBackStepOne={onBackStepOne}
          isLoadingOtp={isLoadingOtp}
        />
      )}
      {step === 3 && (
        <DepositSettlementStepThree
          onBackStepOne={onBackStepOne}
          dataStepThree={dataStepThree}
        />
      )}
    </>
  );
};

export default DepositSettlementContainer;
